import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9ad77ea0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "lecture-card"
};
const _hoisted_2 = {
  class: "card_left"
};
const _hoisted_3 = {
  class: "time_box"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "circle_line"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "circle"
})], -1));

const _hoisted_6 = {
  class: "card_right_top"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "title_name"
};
const _hoisted_9 = {
  key: 1,
  style: {
    "color": "#3071e5",
    "margin-left": "3px"
  }
};
const _hoisted_10 = {
  key: 0,
  class: "option_btn"
};
const _hoisted_11 = {
  key: 0,
  class: "guankan"
};
const _hoisted_12 = {
  key: 1,
  class: "guankan2"
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 1,
  class: "lecture-status"
};
const _hoisted_17 = {
  key: 2,
  class: "lecture-status"
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 0,
  class: "lecture-status"
};
const _hoisted_20 = {
  key: 1
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 报名 ");

const _hoisted_22 = {
  key: 1,
  class: "lecture-status"
};
const _hoisted_23 = {
  key: 1,
  class: "living-text"
};
const _hoisted_24 = {
  class: "card_right_bottom"
};
const _hoisted_25 = {
  class: "bottom_left"
};
const _hoisted_26 = {
  key: 0
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主讲人：", -1));

const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "teacher-name"
};
const _hoisted_30 = {
  key: 1
};
const _hoisted_31 = {
  key: 2
};

const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 报名人数： ");

const _hoisted_33 = {
  class: "text"
};
const _hoisted_34 = {
  key: 3
};

const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 培训地点： ");

const _hoisted_36 = {
  class: "text"
};

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "  /  线下活动", -1));

const _hoisted_38 = {
  class: "bottom_right"
};
const _hoisted_39 = ["src"];

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right_line"
}, null, -1));

import liveIcon from 'components/liveIcon';
import { getUrlParams } from '@/plugins/utils';
import ApplyDrawDialog from './ApplyDrawDialog.vue';
import DrawResultDialog from './DrawResultDialog.vue';
export default {
  props: {
    lectureData: Object,
    index: Number
  },
  emits: ['updateStatus'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const $utils = inject('$utils');
    const userInfo = inject('userInfo');
    const $baseUrl = inject('$baseUrl');
    const menuInfo = reactive({
      menuId: getUrlParams('menuId'),
      menuName: getUrlParams('name')
    }); // 格式化会议时间

    const formatLectureTime = startTime => {
      return $utils.formatDate(startTime, 'YYYY.MM.DD HH:mm');
    };

    const defaultCover = computed(() => {
      if (props.lectureData.type == 1) {
        return props.index < 2 ? `lecture_online${props.index + 1}` : `lecture_online${props.index % 2 + 1}`;
      } else {
        return props.index < 2 ? `lecture_offline${props.index + 1}` : `lecture_offline${props.index % 2 + 1}`;
      }
    }); // 是否可以报名抽签
    // is_draw 活动抽签 0.不启用 1.启用
    // applicants_time_status 0报名时间未到 1可以开始报名 2 报名已结束
    // is_applicants 活动报名 0.不启用 1.启用
    // draw_type 1 报名完抽签成功 2 报名成功未抽中 3报名完成等待抽签 4报名成功可以开始抽签 5未报名

    const formatApplyStauts = computed(() => {
      if (props.lectureData.limit_num == -1 || props.lectureData.applicants_count < props.lectureData.limit_num) {
        if (props.lectureData.is_draw == 1) {
          // 开启抽签
          if (props.lectureData.draw_type == 4) {
            return true;
          } else if (props.lectureData.draw_type == 5) {
            return props.lectureData.applicants_time_status == 1 ? true : false;
          }
        } else {
          return props.lectureData.is_applicants == 1 ? props.lectureData.applicants_time_status == 1 ? true : false : true;
        }
      }

      return false;
    }); // 教师显示

    const formatTeacher = () => {
      const {
        teacher_name,
        school_name,
        job_title,
        college_name
      } = props.lectureData.teacherDtoList[0];
      const length = props.lectureData.teacherDtoList.length;

      if (length > 1) {
        return teacher_name + `等${length}名老师`;
      } else {
        return teacher_name + (!(school_name && college_name && job_title) ? '' : '-' + (school_name || '') + (college_name || '') + (job_title || ''));
      }
    }; // 报名 type 1 报名完抽签成功 2 报名成功未抽中 3报名完成等待抽签 4报名成功可以开始抽签 5未报名


    const currentLiveId = ref('');
    const showApplyDialog = ref(false);

    const handleApply = (type, id) => {
      if (type == 4) {
        currentLiveId.value = id;
        showApplyDialog.value = true;
      } else {
        goDetail(id);
      }
    }; // 抽签结果


    const showResultDialog = ref(false);
    const ballotStatus = ref(0);

    const ballotResult = result => {
      ballotStatus.value = result;
      showResultDialog.value = true;
      emit('updateStatus');
    }; // 点击卡片去详情页


    const goDetail = id => {
      window.location.href = `${$baseUrl}/lectureDetail.html?menuId=${menuInfo.menuId}&name=${menuInfo.menuName}&id=${id}`;
    };

    return (_ctx, _cache) => {
      const _component_ArrowRight = _resolveComponent("ArrowRight");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, _toDisplayString(formatLectureTime(__props.lectureData.start_time)), 1), _hoisted_4, _createElementVNode("div", null, _toDisplayString(formatLectureTime(__props.lectureData.end_time)), 1)]), _hoisted_5]), _createElementVNode("div", {
        class: "card_right",
        onClick: _cache[1] || (_cache[1] = $event => goDetail(__props.lectureData.id))
      }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(__props.lectureData.live_name), 1), __props.lectureData.type == 1 && __props.lectureData.live_status == -2 ? (_openBlock(), _createBlock(_unref(liveIcon), {
        key: 0,
        class: "living-icon",
        color: "#3071E5"
      })) : _createCommentVNode("", true), __props.lectureData.type == 1 && __props.lectureData.live_status == -2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 进行中 ")) : _createCommentVNode("", true)]), __props.lectureData.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [__props.lectureData.live_status == -2 ? (_openBlock(), _createElementBlock("div", _hoisted_11, "观看直播")) : _createCommentVNode("", true), __props.lectureData.live_status == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "直播未开始")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), __props.lectureData.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_unref(userInfo) && __props.lectureData.live_status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [__props.lectureData.is_draw == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_unref(formatApplyStauts) ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        plain: "",
        class: "living-btn",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleApply(__props.lectureData.draw_type, __props.lectureData.id), ["stop"]))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.lectureData.draw_type == 5 ? '报名' : '参与报名抽签') + " ", 1), _createVNode(_component_el_icon, {
          class: "arrow-icon"
        }, {
          default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), __props.lectureData.draw_type < 4 ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(__props.lectureData.draw_type == 1 ? '已成功报名，请按时参加' : __props.lectureData.draw_type == 2 ? '未抽中，欢迎关注后续活动' : '已报名，请关注后续报名抽签'), 1)) : _createCommentVNode("", true), __props.lectureData.applicants_count == __props.lectureData.limit_num && __props.lectureData.draw_type == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_17, " 名额已满，下次再约吧 ")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [__props.lectureData.applicants_status > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_19, " 已报名，请按时参加 ")) : _createCommentVNode("", true), __props.lectureData.applicants_status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_unref(formatApplyStauts) ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        plain: "",
        class: "living-btn"
      }, {
        default: _withCtx(() => [_hoisted_21, _createVNode(_component_el_icon, {
          class: "arrow-icon"
        }, {
          default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true), __props.lectureData.applicants_count == __props.lectureData.limit_num ? (_openBlock(), _createElementBlock("span", _hoisted_22, " 名额已满，下次再约吧 ")) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]))])) : _createCommentVNode("", true), __props.lectureData.live_status == -2 ? (_openBlock(), _createElementBlock("span", _hoisted_23, "活动进行中")) : _createCommentVNode("", true), !_unref(userInfo) && __props.lectureData.live_status == 0 ? (_openBlock(), _createBlock(_component_el_button, {
        key: 2,
        plain: "",
        class: "living-btn"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.lectureData.is_draw ? '参与报名抽签' : '报名') + " ", 1), _createVNode(_component_el_icon, {
          class: "arrow-icon"
        }, {
          default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [__props.lectureData.teacherDtoList && __props.lectureData.teacherDtoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_hoisted_27, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lectureData.teacherDtoList, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("img", {
          src: item.file_url || require('@/assets/images/common/teacher_icon.png'),
          class: "teacher-icon",
          key: index
        }, null, 8, _hoisted_28)), [[_vShow, index < 3]]);
      }), 128)), _createElementVNode("span", _hoisted_29, _toDisplayString(formatTeacher()), 1)])) : _createCommentVNode("", true), __props.lectureData.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_30, "线上直播")) : _createCommentVNode("", true), __props.lectureData.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_hoisted_32, _createElementVNode("span", _hoisted_33, _toDisplayString(__props.lectureData.applicants_count) + "/" + _toDisplayString(__props.lectureData.limit_num > 0 ? `上限${__props.lectureData.limit_num}人` : '人数无上限'), 1)])) : _createCommentVNode("", true), __props.lectureData.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_hoisted_35, _createElementVNode("span", _hoisted_36, _toDisplayString(__props.lectureData.address), 1), _hoisted_37])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_38, [_createElementVNode("img", {
        src: __props.lectureData.live_cover_url || require(`@/assets/images/lecture/${_unref(defaultCover)}.png`),
        width: "303",
        height: "162",
        alt: ""
      }, null, 8, _hoisted_39)])])]), _hoisted_40]), _createVNode(ApplyDrawDialog, {
        show: showApplyDialog.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => showApplyDialog.value = $event),
        "live-id": currentLiveId.value,
        onBallotResult: ballotResult
      }, null, 8, ["show", "live-id"]), _createVNode(DrawResultDialog, {
        show: showResultDialog.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => showResultDialog.value = $event),
        status: ballotStatus.value
      }, null, 8, ["show", "status"])], 64);
    };
  }

};